'use strict';

angular.module('clientDashboardApp').directive('exportReportData', function ($uibModal, $timeout) {
    return {
        restrict: 'A',
        scope: {
            searchResult: '=',
            dropdown: '=',
            text: '@',
            iconOnly: '=',
            replaceClass: '@',
            linkOverride: '=',
            responsive: '@',
            disabledTime: '='
        },
        template: `
            <button ng-if="!dropdown && !linkOverride" class="btn btn-outline-secondary" ng-class="replaceClass ? replaceClass : ''" ng-click="openModal()">
                <i ng-if="!dropdown" class="fas fa-cloud-download"></i>
                <span>{{ iconOnly ? "" : text || "Download"}}</span>
            </button>
            <a tabindex="0" ng-href="{{linkOverride}}" ng-click="clicked()" ng-if="!dropdown && linkOverride" class="btn btn-outline-secondary {{ replaceClass ? replaceClass : ''}}" ng-class="{disabled: 'disabled'}">
                <i ng-if="!dropdown" class="fas fa-cloud-download"></i>
                <span>{{ iconOnly ? "" : text || "Download"}}</span>
            </a>
            <span ng-if="dropdown" ng-click="openModal()">
                {{iconOnly ? "" : text || "Download"}}
            </span>
        `,
        controller: function ($scope,$location) {
            var maxExport = 50000;
            $scope.disabled = false;
            $scope.clicked = function() {
                if ($scope.disabledTime) {
                    $scope.disabled = true;
                    $timeout(() => $scope.disabled = false, $scope.disabledTime * 1000)
                }
            }

            $scope.openModal = () => {

                if (!$scope.searchResult) {
                  return;
                }

                $uibModal.open({
                    template: require('./export/exportDataModal.html'),
                    controller: 'ExportDataModalCtrl',
                    resolve: {
                        exportOptions: function () {
                          var numberOfResults = $scope.searchResult ? $scope.searchResult.totalResults : 0;
                          return {
                                numberOfResults: numberOfResults,
                                maxExport: maxExport,
                                searchResult: $scope.searchResult
                            };
                        }
                    }
                });
            };
        }
    }
});
